import React from 'react';
import * as BuilderUI from '../../BuilderUI';
import ReroutingEventsMenu from './ReroutingEventsMenu';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  addExpandEventAction,
  addFoldEventAction,
  addMergeEventAction,
  RowType,
} from '../../../../redux/slices/oldBuilder';
import {
  MAX_EXPAND_EVENTS,
  MAX_FOLD_EVENTS,
  MAX_MERGE_EVENTS,
} from '../../../../config/constants';
import ExpandEvent from './ExpandEvent';
import MergeEvent from './MergeEvent';
import FoldEvent from './FoldEvent';
import EventsExpansionDropzone from './EventsExpansionDropzone';
interface IProps {
  allowExpand: boolean;
  allowFold: boolean;
  allowMerge: boolean;
}

const ReroutingEvents = ({ allowExpand, allowFold, allowMerge }: IProps) => {
  const dispatch = useAppDispatch();

  const expandEvents =
    useAppSelector(({ builder }) => builder[RowType.expandEvents]) ?? [];
  const mergeEvents =
    useAppSelector(({ builder }) => builder[RowType.mergeEvents]) ?? [];
  const foldEvents =
    useAppSelector(({ builder }) => builder[RowType.foldEvents]) ?? [];

  const handleAddExpandEvent = () => {
    dispatch(addExpandEventAction());
  };
  const handleAddMergeEvent = () => {
    dispatch(addMergeEventAction());
  };
  const handleAddFoldEvent = () => {
    dispatch(addFoldEventAction());
  };

  const allowAddExpand = expandEvents?.length < MAX_EXPAND_EVENTS;
  const allowAddMerge = mergeEvents?.length < MAX_MERGE_EVENTS;
  const allowAddFold = foldEvents?.length < MAX_FOLD_EVENTS;

  return (
    <BuilderUI.SectionColumn>
      <ReroutingEventsMenu
        onAddExpand={allowExpand ? handleAddExpandEvent : undefined}
        onAddFold={allowFold ? handleAddFoldEvent : undefined}
        onAddMerge={allowMerge ? handleAddMergeEvent : undefined}
        disableExpand={!allowAddExpand}
        disableFold={!allowAddFold}
        disableMerge={!allowAddMerge}
      />

      <EventsExpansionDropzone />

      {expandEvents.length > 0 &&
        expandEvents.map((_, index) => (
          <ExpandEvent key={`expand-event-${index}`} index={index} />
        ))}
      {mergeEvents.length > 0 &&
        mergeEvents.map((_, index) => (
          <MergeEvent
            key={`merge-event-${index}`}
            index={index}
            rowMeta={{
              rowType: RowType.mergeEvents,
              rowIndex: index,
              eventIndex: 0,
            }}
          />
        ))}
      {foldEvents.length > 0 &&
        foldEvents.map((foldEvent, index) => (
          <FoldEvent
            key={`fold-event-${index}`}
            foldEvent={foldEvent}
            index={index}
            rowMeta={{
              rowType: RowType.foldEvents,
              rowIndex: index,
            }}
          />
        ))}
    </BuilderUI.SectionColumn>
  );
};

export default ReroutingEvents;
